module.exports = __webpack_public_path__ + "img/title-2.21a21ed4.png";